import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@app/app-config.service';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class TranslationService implements TranslateLoader {
  /**
   * The constructor
   *
   * @param http an HttpClient instance
   * @param appConfigService the AppConfigService instance
   */
  constructor(private http: HttpClient, private appConfigService: AppConfigService) {}

  /**
   * Get the translation for a given language
   *
   * @param lang the language
   * @return an observable with the translations
   */
  getTranslation(lang: string): Observable<any> {
    return this.http.get(`${this.appConfigService.getApi()}/public/translation/${lang}`).pipe(catchError(_ => of({})));
  }
}
